// Axcient tooltip plugin version 1.0

;(function($){

	$.fn.axTooltip = function(options) {
		var settings = {};
		var ttid = 0;

		if (options){
			$.extend( settings, options );
		}

		$(document).on('mouseover', '[data-axtooltip]', function(i){

	        var $this = $(this);
	        var $_body = $('body');

			// Skip elements that already have tooltip applied to them.
			if ($this.data('axTooltipId')){
        return true;
			}
      // For truncated types, skips those whose content isn't truncated unless the force flag is enabled.
      if ($this.data("axtooltipTrunc") && this.offsetWidth >= this.scrollWidth && !$this.data('axtooltipForce')) {
          return true;
      }

			ttid++;
			$this.data('axTooltipId', ttid).attr('data-axTooltipId', ttid);

			// Create new tooltip element to add
			var $newdiv = $('<div class="axTooltip">');

			var content = '<div class="triangle"></div>';
			if ($this.attr("data-axtooltip-title")){
			  content += '<div class="tooltip_title">' + $this.attr("data-axtooltip-title") + '</div>';
			}

			content += "<div class='tooltip_body'>" + $this.attr("data-axtooltip") + "</div>";
			$newdiv.html(content);
			$_body.after($newdiv);

			if( $this.attr( 'data-axtooltip-class' )){
			  $newdiv.addClass( $this.attr( 'data-axtooltip-class' ));
			}

			var interval = setInterval(function () {
			    if ( $('*[data-axTooltipId="' + $newdiv.data("axTooltipId") + '"]').length == 0 ) {
			      clearInterval(interval);
			      $newdiv.remove();
			     }
			  }, 200);

			var line_height = parseInt($this.css('line-height'), 10);

			if (isNaN(line_height)) {
			  line_height = $this.outerHeight(true);
			}

			var content_left_offset = $_body.offset().left;
			var content_width = $_body.outerWidth();
			/* distance from left content bar until icon */
			var offset = $this.offset().left - content_left_offset;

			$newdiv.css('z-index', 9002);
			$newdiv.data('axTooltipId', ttid);

			/* If icon lands in the rightmost 1/5 of the page render
			 * the text above the icon, rather than on the right */
			if (offset/content_width > 0.8) {

				/* If the window is shrunk, we need to force the width */
				if ($(document).width() - $(window).width() > 0) {
					$newdiv.css('min-width', '200px')
				}

				/* Position the text box above the icon */
				$newdiv.css({
					'left'  : $this.offset().left - $newdiv.width() + 1,
					'top'   : $this.offset().top - $newdiv.outerHeight() - 4,
					'box-shadow'  : '1px 1px 2px #444444'
				})
				/* Adjust the triangle pointer image */
				.find('.triangle').css({
					'transform'      : 'rotate(270deg)',
					'top'   : $newdiv.innerHeight() - 4,
					'left'  : $newdiv.width() + 1
				});

      } else if ($this.attr("data-axtooltip-position") === "bottom") {
        /* Position the text box to the bottom of the object */
        $newdiv.css({
          'left'  : $this.offset().left - $newdiv.width() / 2 + 1,
          'top'   : $this.offset().top + $this.height() + 10,
        }).find('.triangle').css({
          'transform'      : 'rotate(90deg)',
          'left'  : $newdiv.width() / 2,
          'top' : - ($newdiv.outerHeight() - $newdiv.height()) / 2 - 4,
        });
      } else if ($this.attr("data-axtooltip-position") === "rightInTable") {
        $newdiv.css({
          'left'  : $this.offset().left + $this.width() + 10,
          'top'   : $this.offset().top - $newdiv.outerHeight() / 2 + (line_height / 2 + 1)
        }).find('.triangle').css({
          'top' : $newdiv.outerHeight() / 2 - 8
        });
      } else {
				/* Position the text box to the right of the icon */
				$newdiv.css({
					'left'  : $this.offset().left + $this.width() + 10,
					'top'   : $this.offset().top - $newdiv.outerHeight() / 2 + (line_height / 2 - 4)
				}).find('.triangle').css({
					'top' : $newdiv.outerHeight() / 2 - 8
				});
			}

      /* If tooltip is not flagged as instant, include a small delay that clears on mouseout. */
		  if($this.data("axtooltipInstant")) {
        $newdiv.show();
      } else {
        var tooltipDelay = setTimeout(function() {
          $newdiv.show();
        }, 800);
      }

		  $this.mouseout(function(){
		    clearInterval(interval);
        tooltipDelay && clearTimeout(tooltipDelay);
		    $newdiv.remove();
		    $this.data('axTooltipId', null);
		  });
		});
	};
})( jQuery );

$(document).ready(function($){
	$().axTooltip();
});
